module.exports = __webpack_public_path__ + "static/grandma-3e60b332336d5eaa8689b5f5bfa2c38e.svg";